import {
  Box,
  Button,
  Card,
  CardMedia,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import imageIndex from "../ImageIndex";

const workshops = [
  {
    id: "astronomy",
    title: "Talleres astronómicos",
    image: imageIndex.TalleresAstronomia,
    description: "(que lleve al formulario)",
  },
  {
    id: "aerospace",
    title: "Talleres aeroespaciales",
    image: imageIndex.TalleresAeroespaciales,
  },
  {
    id: "aeronautical",
    title: "Talleres aeronáuticos",
    image: imageIndex.TalleresAeronauticos,
  },
];

export const CourseCatalog = () => {
  return (
    <Box
      component="section"
      sx={{
        py: 8,
        px: 2, // Reduced padding on mobile
      }}
    >
      <Container maxWidth="lg">
        {/* Header */}
        <Box
          sx={{
            textAlign: "center",
            mb: { xs: 6, sm: 12 }, // Smaller margin on mobile
          }}
        >
          <Typography
            variant="h1"
            sx={{
              mb: 3,
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" }, // More responsive font sizes
              fontWeight: "bold",
              px: 2, // Add horizontal padding to prevent overflow
              wordBreak: "break-word", // Prevent text overflow
            }}
          >
            Catálogo de cursos, talleres y actividades
          </Typography>
        </Box>

        {/* Workshop Cards Grid */}
        <Grid container spacing={3}>
          {" "}
          {/* Reduced spacing on mobile */}
          {workshops.map((workshop) => (
            <Grid item key={workshop.id} xs={12} sm={6} md={4}>
              <Card
                sx={{
                  height: { xs: 400, sm: 460 }, // Adjusted height for mobile
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 4,
                  overflow: "hidden",
                  boxShadow: 4,
                  transition: "all 0.3s ease",
                  mx: "auto", // Center the card
                  maxWidth: { xs: 350, sm: "none" }, // Limit width on mobile
                  "&:hover": {
                    transform: { xs: "none", sm: "translateY(-8px)" }, // Disable hover effect on mobile
                    boxShadow: { xs: 4, sm: 8 },
                    cursor: { xs: "default", sm: "pointer" },
                  },
                }}
              >
                {/* Background Image */}
                <Box
                  sx={{
                    position: "relative",
                    height: { xs: 250, sm: 300 }, // Adjusted image height
                    overflow: "hidden",
                  }}
                >
                  <CardMedia
                    component="img"
                    image={workshop.image}
                    alt={workshop.title}
                    sx={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                      transition: { xs: "none", sm: "transform 0.5s ease" }, // Disable zoom on mobile
                      "&:hover": {
                        transform: { xs: "none", sm: "scale(1.1)" },
                      },
                    }}
                  />

                  {/* Overlay for better text contrast */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(33,47,148,0.2)",
                    }}
                  />
                </Box>

                {/* Content Overlay */}
                <Box
                  sx={{
                    position: "relative",
                    p: { xs: 3, sm: 6 }, // Reduced padding on mobile
                    color: "common.white",
                    background:
                      "linear-gradient(to top, #212f6c, #17265c, #0d1e4c, #04163d, #010a2f)",
                    mt: { xs: -6, sm: -8 }, // Adjusted negative margin
                    zIndex: 1,
                    flex: 1, // Take remaining space
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between", // Better content distribution
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      mb: 2,
                      fontWeight: "bold",
                      fontSize: { xs: "1.2rem", sm: "1.5rem", md: "2rem" }, // More responsive
                      textAlign: "center", // Center text on mobile
                      wordBreak: "break-word", // Prevent overflow
                    }}
                  >
                    {workshop.title}
                  </Typography>

                  <Button
                    variant="contained"
                    size="small"
                    fullWidth
                    color="primary"
                    onClick={() =>
                      window.open(
                        "https://forms.gle/5osu5SVm1jEZC4qU7",
                        "_blank"
                      )
                    }
                    sx={{
                      mt: { xs: 2, sm: 3 }, // Adjusted margin
                    }}
                  >
                    SOLICITAR
                  </Button>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
